import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Quick Links</h3>
                    <ul className="footer-links">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3>Follow Me</h3>
                    <div className="social-icons">
                        <a href="https://linkedin.com/in/pawelpiwosz" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <i className="fa-brands fa-linkedin fa-lg"></i>
                        </a>
                        <a href="https://github.com/pawelpiwosz" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                            <i className="fa-brands fa-github fa-lg"></i>
                        </a>
                        <a href="https://dev.to/pawelpiwosz" target="_blank" rel="noopener noreferrer" aria-label="Dev.to">
                            <i className="fa-brands fa-dev fa-lg"></i>
                        </a>
                        <a href="https://medium.com/pawelpiwosz" target="_blank" rel="noopener noreferrer" aria-label="Medium.com">
                            <i className="fa-brands fa-medium fa-lg"></i>
                        </a>
                        <a href="https://www.youtube.com/@devopsinagileway" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <i className="fa-brands fa-youtube fa-lg"></i>
                        </a>
                        <a href="https://www.youtube.com/@ohmycloud-pl" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <i className="fa-brands fa-youtube fa-lg"></i>
                        </a>
                    </div>
                </div>
                <div className="footer-section">
                    <h3>My Other Pages</h3>
                    <ul className="footer-links">
                        <li><a href="https://cicd.run" target="_blank" rel="noopener noreferrer">cicd.run</a></li>
                        <li><a href="https://nothankyou.fyi" target="_blank" rel="noopener noreferrer">nothankyou.fyi</a></li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Pawel Piwosz. All rights reserved.</p>
                <p className="ai-credit">
                    This website was created with assistance from <a href="https://github.com/features/copilot" target="_blank" rel="noopener noreferrer">GitHub Copilot</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;